import { render, staticRenderFns, recyclableRender, components } from "./study-coins.vue?vue&type=template&id=30c989d9&scoped=true&"
var renderjs
import script from "./study-coins.vue?vue&type=script&lang=js&"
export * from "./study-coins.vue?vue&type=script&lang=js&"
import style0 from "./study-coins.vue?vue&type=style&index=0&id=30c989d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c989d9",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/mine/account/study-coins.vue"
export default component.exports